import { DataType } from 'components/table/types';
import { SignerDashboardTableType } from 'constants/requests.constants';

export type tableColumns = Record<SignerDashboardTableType, Record<string, DataType>>;
const commonColumns: Record<string, DataType> = {
	hebrewName: 'string',
	transferOrigin: 'string',
	amount: 'number',
	openAccountNumber: 'string',
	createdAt: 'date',
};
export const tableColumns: tableColumns = {
	[SignerDashboardTableType.IN_PROGRESS_REQUESTS]: {
		boApprovedByUser: 'string',
		boSecondarySignerApprovalDate: 'date',
		...commonColumns,
	},
	[SignerDashboardTableType.COMPLETED_REQUESTS]: {
		boApprovedByUser: 'string',
		boApprovalDate: 'string',
		boApprovedBySecondUser: 'string',
		boSecondarySignerApprovalDate: 'string',
		...commonColumns,
		status: 'string',
	},
};
